import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import RoundConfig from './Config/RoundConfig';
import TextFFXIV from '@/app/components/TextFFXIV';
import ChallengeConfig from './Config/ChallengeConfig';
import TooltipWithIconFFXIV from '@/app/components/TooltipWithIconFFXIV';

const HazardModeAdvancedSettings: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    return (
        <div className={`flex flex-col gap-4 ${!isGameMaster ? 'opacity-50' : ''}`}>
            <div className="flex items-center justify-center gap-2">
                <TextFFXIV text={t('game.config.advancedSettings.title')} className="text-center" />
                <TooltipWithIconFFXIV
                    text={t('game.modes.hazard.warning')}
                    warning={true}
                />
            </div>
            <RoundConfig />
            <ChallengeConfig
                forceHazards={true}
                showFlash={false}
            />
            <div className="text-red-400 text-center sm:hidden">{t('game.modes.hazard.warningMobile')}</div>
        </div>
    );
};

export default HazardModeAdvancedSettings;
